module.exports = __webpack_public_path__ + "img/36.df0418a8.png";